export default __webpack_public_path__ + "static/media/219.c983db7c.gif";